import { render, staticRenderFns, recyclableRender, components } from "./tn-calendar.vue?vue&type=template&id=021dc194&scoped=true&"
var renderjs
import script from "./tn-calendar.vue?vue&type=script&lang=js&"
export * from "./tn-calendar.vue?vue&type=script&lang=js&"
import style0 from "./tn-calendar.vue?vue&type=style&index=0&id=021dc194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../软件/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021dc194",
  null,
  false,
  components,
  renderjs
)

export default component.exports